// import React, { useEffect, useState } from "react";
// import {
//   Grid,
//   Typography,
//   Box,
//   Paper,
//   RadioGroup,
//   FormControlLabel,
//   Radio,
// } from "@mui/material";
// import { useForm } from "react-hook-form";
// import { useDispatch, useSelector } from "react-redux";
// import { ToastContainer, toast } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";

// import ControlledTextInputField from "../../component/ui/FormFields/ControlledTextInputField";
// import CustomButton from "../../component/ui/FormFields/Button";
// import {
//   addAirportRequest,
//   resetAirportState,
// } from "../../redux/Airports/actions/airportActions";
// import {
//   selectCountryAirportRequest,
//   selectStateAirportRequest,
// } from "../../redux/Common/selectorAction";

// import {
//   AIRPORTS,
//   EDITPROMO,
//   PROMOCODE,
// } from "../../component/common/Routes/AppRoutes";
// import { useNavigate, useParams } from "react-router-dom";
// import {
//   LocationOn,
//   FlightLand,
//   FlightTakeoff,
//   TransferWithinAStation,
// } from "@mui/icons-material";
// import { fetchAllServiceRequest } from "../../redux/Service/ServiceAction";
// import StatusRadioGroup from "../../component/ui/FormFields/StatusRadioGroup";
// import TextInputField from "../../component/ui/FormFields/TextInputField";
// import {
//   approvalPromoCodeRequest,
//   resetApprovalPromoCode,
//   viewPromoCodeRequest,
// } from "../../redux/PromoCode/PromoCodeAction";
// import { formatDateWithAmPm } from "../../Style";
// import Loading from "../../component/ui/Loading";

// export default function ViewPromoCode() {
//   const dispatch = useDispatch();
//   const {
//     control,
//     handleSubmit,
//     watch,
//     setValue,
//     formState: { errors },
//   } = useForm({
//     defaultValues: {},
//     mode: "onChange",
//   });
//   const formValue = watch();
//   const user = useSelector((state) => state.auth.user);
//   const [approvalStatus, setApprovalStatus] = useState("");
//   const [rejectionReason, setRejectionReason] = useState("");
//   const [initialStatus, setInitialStatus] = useState("");
//    const loading = useSelector((state) => state.promoCode.viewPromoCode.loading);
//    const approvalLoading = useSelector((state) => state.promoCode.approvalPromoCode.loading);
//    const approvalPromoCodeSuccess = useSelector((state) => state.promoCode.approvalPromoCode.success);
//    const approvalPromoCodeError = useSelector((state) => state.promoCode.approvalPromoCode.error);

//   const promoCodeDetails = useSelector(
//     (state) => state.promoCode?.viewPromoCode?.data || {}
//   );

//   const { id } = useParams();

//   const discountType = formValue.discount_type;
//   const handleApprovalStatusChange = (e) => {
//     setApprovalStatus(e.target.value);
//     if (e.target.value !== "3") {
//       setRejectionReason("");
//     }
//   };
//   const handleApprovalStatusSubmit = async () => {
//     if (approvalStatus === "3" && !rejectionReason.trim()) {
//       toast.error("Please enter a rejection reason.", {
//               position: 'top-center',
//               autoClose: 3000,

//             });
//       return;
//     }

//     dispatch(
//       approvalPromoCodeRequest({id,
//         approval_status: approvalStatus,
//         rejection_reason: rejectionReason,
//       })
//     );
//   };

//   const promoFields = [
//     {
//       name: "title",
//       label: "Title *",
//       disabled: true,
//       placeholder: "Enter PromoCode Title",
//       rules: { required: "Discount Title is required" },
//       sm: 6,
//     },

//     {
//       name: "discount_code",
//       disabled: true,
//       label: "Discount Code *",
//       placeholder: "Enter Discount Code",
//       rules: {
//         required: "Discount Code is required",
//         validate: (value) => {
//           if (value.length < 4) {
//             return "Discount Code must be at least 4 characters";
//           }
//           if (value.length > 8) {
//             return "Discount Code must not exceed 8 characters";
//           }
//           return true;
//         },
//       },
//       sm: 6,
//     },
//     {
//       name: "discount_type",
//       label: "Discount Type",
//       disabled: true,

//       sm: 6,
//     },
//     ...(discountType?.value == 2
//       ? [
//           {
//             name: "discount_value",
//             label: "Discount Value *",
//             disabled: true,
//             placeholder: "Enter Discount Value",
//             rules: { required: "Discount Value is required" },
//             sm: 6,
//           },
//         ]
//       : [
//           {
//             name: "discount_percent",
//             label: "Discount Percentage *",
//             placeholder: "Enter Discount Percentage 0-100%",
//             disabled: true,
//             rules: {
//               required: "Percentage is required",
//               min: { value: 0, message: "Percentage should not be negative" },
//               max: {
//                 value: 100,
//                 message: "Percentage must be less than or equal to 100",
//               },
//             },
//             sm: 6,
//           },
//         ]),

//     {
//       name: "usage_limit",
//       label: "Use Limit *",
//       disabled: true,
//       placeholder: "Set Promo Code Use Limit",
//       rules: {
//         required: "Promo Code Limit is Required",
//         min: { value: 1, message: "Usage limit must greater than 0" },
//       },

//       sm: 6,
//     },

//     {
//       name: "valid_from",
//       label: "Valid From *",
//       placeholder: "Select date ",
//       type: "datebooking",
//       disabled: true,
//       instantBooking: "true",
//       rules: { required: "Date is required" },
//       xs: 12,
//       sm: 6,
//     },
//     {
//       name: "valid_to",
//       label: "Valid To *",
//       placeholder: "Select date ",
//       disabled: true,
//       type: "datebooking",
//       instantBooking: "true",
//       rules: { required: "Date is required", validate: {} },
//       xs: 12,
//       sm: 6,
//     },
//     {
//       name: "description",
//       disabled: true,
//       label: "Description ",
//       placeholder: "Enter Promo Code Description ",
//       type: "textarea",

//       xs: 12,
//     },
//   ];
//   useEffect(() => {
//     if (approvalPromoCodeSuccess) {
//       toast.success(approvalPromoCodeSuccess, {
//         position: 'top-center',
//         autoClose: 3000,
//         onClose: () => {
//           dispatch(resetApprovalPromoCode());

//         },
//       });
//     }
//     if (approvalPromoCodeError) {
//       toast.error(approvalPromoCodeError, {
//         position: 'top-center',
//         autoClose: 3000,
//         onClose: () => {
//           dispatch(resetApprovalPromoCode());

//         },
//       });
//     }
//   }, [approvalPromoCodeSuccess,approvalPromoCodeError]);
//   useEffect(() => {
//     if (id) {
//       dispatch(viewPromoCodeRequest(id));
//     }
//   }, [id]);
//   useEffect(() => {
//     if (Object.keys(promoCodeDetails).length > 0) {
//       setValue("title", promoCodeDetails.title);
//       setValue("discount_code", promoCodeDetails.discount_code);
//       setValue(
//         "discount_type",
//         promoCodeDetails.discount_type === 2 ? "Price ($)" : "Discount (%)"
//       );
//       setValue("discount_value", promoCodeDetails.discount_value);
//       setValue("discount_percent", promoCodeDetails.discount_percent);
//       setValue("usage_limit", promoCodeDetails.usage_limit);
//       setValue("valid_from", formatDateWithAmPm(promoCodeDetails.valid_from));
//       setValue("valid_to", formatDateWithAmPm(promoCodeDetails.valid_to));
//       setValue("description", promoCodeDetails.description);
//       setValue("status", promoCodeDetails.status === 1 ? "Active" : "Inactive");
//       setApprovalStatus(promoCodeDetails.approval_status);
//       setValue(
//         "approval_status",
//         promoCodeDetails.approval_status === 1
//           ? "Approved"
//           : promoCodeDetails.approval_status === 2
//           ? "Pending"
//           : "Rejected"
//       );
//       setValue("rejection_reason", promoCodeDetails.rejection_reason);
//     }
//   }, [promoCodeDetails]);
//     if (loading) {
//       return <Loading text="Loading Promo Code Details..." />;
//     }
//   return (
//     <Box component={Paper} sx={{ margin: "30px", padding: "30px" }}>
//       <Typography variant="h5" mb={2}>
//         View PromoCode
//       </Typography>
//       <form onSubmit={handleSubmit()}>
//         <Grid container spacing={2}>
//           {promoFields.map((field) => (
//             <Grid item xs={12} sm={field.sm} key={field.name}>
//               <ControlledTextInputField
//                 name={field.name}
//                 control={control}
//                 label={field.label}
//                 multiple={field.multiple}
//                 placeholder={field.placeholder}
//                 disabled={field.disabled}
//                 options={field.options}
//                 rules={field.rules}
//                 instantBooking={field.instantBooking}
//                 type={field.type}
//                 error={!!errors[field.name]}
//                 helperText={errors[field.name]?.message}
//               />
//             </Grid>
//           ))}
//           <Grid item xs={12} sm={6}>
//             <StatusRadioGroup
//               name={"status"}
//               control={control}
//               disabled={"true"}
//               defaultValue={"Active"}
//             />
//           </Grid>
//           {(user?.role === "Admin" || user?.role_name === "Manager") && (
//             <Grid item xs={12} sm={6}>
//               <Typography variant="subtitle1" gutterBottom>
//                 Approval Status
//               </Typography>
//               <Grid container spacing={2} direction="row" alignItems="center">
//                 <Grid item>
//                   <RadioGroup
//                     value={approvalStatus}
//                     onChange={handleApprovalStatusChange}
//                     row
//                   >
//                     <FormControlLabel
//                       value={1}
//                       control={<Radio color="success" />}
//                       label="Approved"
//                     />

//                     <FormControlLabel
//                       value={2}
//                       control={<Radio color="warning" />}
//                       label="Pending"
//                     />

//                     <FormControlLabel
//                       value={3}
//                       control={<Radio color="error" />}
//                       label="Rejected"
//                     />
//                   </RadioGroup>
//                 </Grid>
//                 <Grid item>
//                   <CustomButton
//                     variant="contained"
//                     onClick={handleApprovalStatusSubmit}
//                     className="success-button"
//                     loading={approvalLoading}
//                     text="Submit Approval Status"
//                   />
//                 </Grid>
//               </Grid>
//             </Grid>
//           )}
//           {approvalStatus == "3" && (
//             <Grid item xs={12}>
//               <Box className="rejection-reason-box">
//                 <Typography variant="subtitle1" color="error" gutterBottom>
//                   Rejection Reason
//                 </Typography>
//                 <TextInputField
//                   // value={vendorDetails?.rejection_reason}
//                   onChange={(e) => setRejectionReason(e.target.value)}
//                   required
//                   multiline
//                   rows={3}
//                   placeholder="Enter reason for rejection..."
//                 />
//               </Box>
//             </Grid>
//           )}

//           <Grid item xs={12}>
//             <Box className="button-container">
//               <CustomButton
//                 variant="contained"
//                 className="cancel-button"
//                 type="button"
//                 text="Back"
//                 link={PROMOCODE}
//               />
//               <CustomButton
//                 variant="contained"
//                 className="success-button"
//                 type="submit"
//                        link={`${EDITPROMO.replace(':id', id)}`}
//                 text={"Edit"}
//               />
//             </Box>
//           </Grid>
//         </Grid>
//       </form>
//       <ToastContainer />

//     </Box>
//   );
// }
import React, { useEffect, useState } from "react";
import {
  Grid,
  Typography,
  Box,
  Paper,
  RadioGroup,
  FormControlLabel,
  Radio,
  Card,
  CardContent,
} from "@mui/material";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import ControlledTextInputField from "../../component/ui/FormFields/ControlledTextInputField";
import CustomButton from "../../component/ui/FormFields/Button";
import {
  addAirportRequest,
  resetAirportState,
} from "../../redux/Airports/actions/airportActions";
import {
  selectCountryAirportRequest,
  selectStateAirportRequest,
} from "../../redux/Common/selectorAction";

import {
  AIRPORTS,
  EDITPROMO,
  PROMOCODE,
} from "../../component/common/Routes/AppRoutes";
import { useNavigate, useParams } from "react-router-dom";
import {
  LocationOn,
  FlightLand,
  FlightTakeoff,
  TransferWithinAStation,
} from "@mui/icons-material";
import { fetchAllServiceRequest } from "../../redux/Service/ServiceAction";
import StatusRadioGroup from "../../component/ui/FormFields/StatusRadioGroup";
import TextInputField from "../../component/ui/FormFields/TextInputField";
import {
  approvalPromoCodeRequest,
  resetApprovalPromoCode,
  viewPromoCodeRequest,
} from "../../redux/PromoCode/PromoCodeAction";
import { formatDateWithAmPm } from "../../Style";
import Loading from "../../component/ui/Loading";

export default function ViewPromoCode() {
  const dispatch = useDispatch();
  const {
    control,
    handleSubmit,
    watch,
    setValue,
    formState: { errors },
  } = useForm({
    defaultValues: {},
    mode: "onChange",
  });
  const formValue = watch();
  const user = useSelector((state) => state.auth.user);
  const [approvalStatus, setApprovalStatus] = useState("");
  const [rejectionReason, setRejectionReason] = useState("");
  const [initialStatus, setInitialStatus] = useState("");
  const loading = useSelector((state) => state.promoCode.viewPromoCode.loading);
  const approvalLoading = useSelector(
    (state) => state.promoCode.approvalPromoCode.loading
  );
  const approvalPromoCodeSuccess = useSelector(
    (state) => state.promoCode.approvalPromoCode.success
  );
  const approvalPromoCodeError = useSelector(
    (state) => state.promoCode.approvalPromoCode.error
  );
  const navigate = useNavigate();
  const promoCodeDetails = useSelector(
    (state) => state.promoCode?.viewPromoCode?.data || {}
  );

  const { id } = useParams();

  const discountType = formValue.discount_type;

  const handleApprovalStatusChange = (e) => {
    setApprovalStatus(e.target.value);
    if (e.target.value !== "3") {
      setRejectionReason("");
    }
  };

  const handleApprovalStatusSubmit = async () => {
    if (approvalStatus === "3" && !rejectionReason.trim()) {
      toast.error("Please enter a rejection reason.", {
        position: "top-center",
        autoClose: 3000,
      });
      return;
    }

    dispatch(
      approvalPromoCodeRequest({
        id,
        approval_status: approvalStatus,
        rejection_reason: rejectionReason,
      })
    );
  };

  const promoFields = [
    {
      name: "title",
      label: "Title *",
      disabled: true,
      placeholder: "Enter PromoCode Title",
      rules: { required: "Discount Title is required" },
      sm: 6,
      xs: 12,
    },
    {
      name: "discount_code",
      disabled: true,
      label: "Discount Code *",
      placeholder: "Enter Discount Code",
      rules: {
        required: "Discount Code is required",
        validate: (value) => {
          if (value.length < 4) {
            return "Discount Code must be at least 4 characters";
          }
          if (value.length > 8) {
            return "Discount Code must not exceed 8 characters";
          }
          return true;
        },
      },
      sm: 6,
      xs: 12,
    },
    {
      name: "discount_type",
      label: "Discount Type",
      disabled: true,
      sm: 6,
      xs: 12,
    },
    ...(discountType?.value == 2
      ? [
          {
            name: "discount_value",
            label: "Discount Value *",
            disabled: true,
            placeholder: "Enter Discount Value",
            rules: { required: "Discount Value is required" },
            sm: 6,
            xs: 12,
          },
        ]
      : [
          {
            name: "discount_percent",
            label: "Discount Percentage *",
            placeholder: "Enter Discount Percentage 0-100%",
            disabled: true,
            rules: {
              required: "Percentage is required",
              min: { value: 0, message: "Percentage should not be negative" },
              max: {
                value: 100,
                message: "Percentage must be less than or equal to 100",
              },
            },
            sm: 6,
            xs: 12,
          },
        ]),
    {
      name: "usage_limit",
      label: "Use Limit *",
      disabled: true,
      placeholder: "Set Promo Code Use Limit",
      rules: {
        required: "Promo Code Limit is Required",
        min: { value: 1, message: "Usage limit must greater than 0" },
      },
      sm: 6,
      xs: 12,
    },
    {
      name: "valid_from",
      label: "Valid From *",
      placeholder: "Select date ",
      type: "datebooking",
      disabled: true,
      instantBooking: "true",
      rules: { required: "Date is required" },
      xs: 12,
      sm: 6,
    },
    {
      name: "valid_to",
      label: "Valid To *",
      placeholder: "Select date ",
      disabled: true,
      type: "datebooking",
      instantBooking: "true",
      rules: { required: "Date is required", validate: {} },
      xs: 12,
      sm: 6,
    },
    {
      name: "applicable_platform",
      label: "Applicable Platform *",
            disabled: true,
      xs: 12,
      sm: 6,
    },
    {
      name: "description",
      disabled: true,
      label: "Description ",
      placeholder: "Enter Promo Code Description ",
      type: "textarea",
      xs: 12,
    },
  ];

  useEffect(() => {
    if (approvalPromoCodeSuccess) {
      toast.success(approvalPromoCodeSuccess, {
        position: "top-center",
        autoClose: 3000,
        onClose: () => {
          dispatch(resetApprovalPromoCode());
          navigate(PROMOCODE);
        },
      });
    }
    if (approvalPromoCodeError) {
      toast.error(approvalPromoCodeError, {
        position: "top-center",
        autoClose: 3000,
        onClose: () => {
          dispatch(resetApprovalPromoCode());
          navigate(PROMOCODE);
        },
      });
    }
  }, [approvalPromoCodeSuccess, approvalPromoCodeError]);

  useEffect(() => {
    if (id) {
      dispatch(viewPromoCodeRequest(id));
    }
  }, [id]);

  useEffect(() => {
    if (Object.keys(promoCodeDetails).length > 0) {
      setValue("title", promoCodeDetails.title);
      setValue("discount_code", promoCodeDetails.discount_code);
      setValue(
        "discount_type",
        promoCodeDetails.discount_type === 2 ? "Price ($)" : "Discount (%)"
      );
      setValue("applicable_platform", promoCodeDetails.applicable_platform==1 ? "Web" : promoCodeDetails.applicable_platform==2 ? "App" : "Both");
      setValue("discount_value", promoCodeDetails.discount_value);
      setValue("discount_percent", promoCodeDetails.discount_percent);
      setValue("usage_limit", promoCodeDetails.usage_limit);
      setValue("valid_from", formatDateWithAmPm(promoCodeDetails.valid_from));
      setValue("valid_to", formatDateWithAmPm(promoCodeDetails.valid_to));
      setValue("description", promoCodeDetails.description);
      setValue("status", promoCodeDetails.status === 1 ? "Active" : "Inactive");
      setApprovalStatus(promoCodeDetails.approval_status);
      setValue(
        "approval_status",
        promoCodeDetails.approval_status === 1
          ? "Approved"
          : promoCodeDetails.approval_status === 2
          ? "Pending"
          : "Rejected"
      );
      
      setValue("rejection_reason", promoCodeDetails.rejection_reason);
    }
  }, [promoCodeDetails]);

  if (loading) {
    return <Loading text="Loading Promo Code Details..." />;
  }

  return (
    <Box
      className="container"
      sx={{
        padding: "20px",
        height: "100vh",
        overflow: "auto",
        "&::-webkit-scrollbar": {
          width: "8px",
        },
        "&::-webkit-scrollbar-track": {
          background: "#f1f1f1",
          borderRadius: "4px",
        },
        "&::-webkit-scrollbar-thumb": {
          background: "#c1c1c1",
          borderRadius: "4px",
        },
        "&::-webkit-scrollbar-thumb:hover": {
          background: "#a8a8a8",
        },
      }}
    >
      <Card>
        <CardContent className="card" sx={{ padding: "30px" }}>
          <Typography variant="h5" className="form-heading" mb={2}>
            View PromoCode
          </Typography>

          <form onSubmit={handleSubmit()} autoComplete="off">
            <Grid
              container
              rowSpacing={4}
              columnSpacing={{ xs: 1, sm: 1, md: 1, lg: 3 }}
              className="customer-form-margin"
            >
              {promoFields.map((field) => (
                <Grid item xs={field.xs} sm={field.sm} key={field.name}>
                  <ControlledTextInputField
                    name={field.name}
                    control={control}
                    label={field.label}
                    multiple={field.multiple}
                    placeholder={field.placeholder}
                    disabled={field.disabled}
                    options={field.options}
                    rules={field.rules}
                    instantBooking={field.instantBooking}
                    type={field.type}
                    error={!!errors[field.name]}
                    helperText={errors[field.name]?.message}
                  />
                </Grid>
              ))}

              <Grid item xs={12} sm={6}>
                <StatusRadioGroup
                  name={"status"}
                  control={control}
                  disabled={"true"}
                  defaultValue={"Active"}
                />
              </Grid>

              {(user?.role === "Admin" || user?.role_name === "Manager") && (
                <Grid item xs={12} sm={6}>
                  <Typography variant="subtitle1" gutterBottom>
                    Approval Status
                  </Typography>
                  <Grid
                    container
                    spacing={2}
                    direction="row"
                    alignItems="center"
                  >
                    <Grid item>
                      <RadioGroup
                        value={approvalStatus}
                        onChange={handleApprovalStatusChange}
                        row
                      >
                        <FormControlLabel
                          value={1}
                          control={<Radio color="success" />}
                          label="Approved"
                        />
                        <FormControlLabel
                          value={2}
                          control={<Radio color="warning" />}
                          label="Pending"
                        />
                        <FormControlLabel
                          value={3}
                          control={<Radio color="error" />}
                          label="Rejected"
                        />
                      </RadioGroup>
                    </Grid>
                    <Grid item>
                      <CustomButton
                        variant="contained"
                        onClick={handleApprovalStatusSubmit}
                        className="success-button"
                        loading={approvalLoading}
                        text="Submit Approval Status"
                      />
                    </Grid>
                  </Grid>
                </Grid>
              )}

              {approvalStatus == "3" && (
                <Grid item xs={12}>
                  <Box className="rejection-reason-box">
                    <Typography variant="subtitle1" color="error" gutterBottom>
                      Rejection Reason
                    </Typography>
                    <TextInputField
                      value={rejectionReason}
                      onChange={(e) => setRejectionReason(e.target.value)}
                      required
                      multiline
                      rows={3}
                      placeholder="Enter reason for rejection..."
                    />
                  </Box>
                </Grid>
              )}

              <Grid item xs={12}>
                <Box className="button-container">
                  <CustomButton
                    variant="contained"
                    className="cancel-button"
                    type="button"
                    text="Back"
                    link={PROMOCODE}
                  />
                  <CustomButton
                    variant="contained"
                    className="success-button"
                    type="submit"
                    link={`${EDITPROMO.replace(":id", id)}`}
                    text={"Edit"}
                  />
                </Box>
              </Grid>
            </Grid>
          </form>

          <ToastContainer />
        </CardContent>
      </Card>
    </Box>
  );
}
